import api from './../service/apiService';
import { apiUrl } from './../constants/apiUrl';
import { logToKibanna, logKafka, detailsInfo, logOtherInfo, catchJSException } from './../service/logService';
import { XPSEntry, Save, CheckOut, BannerTypes, CheckLQ, HOAFlow, CartServices } from './../constants/actionType';
import { redirectTo } from './redirection';
import { Pages, PAGEACTIVITY,Service } from './../constants/actionType';
import { getCartHeader, getCartData, getCartProducts, getSelectedVoice, getUnsupportedProducts, getCartDataDefault } from './../util/cartUtility';
import { errorAction } from './error';
import * as buildProductAction from './buildProduct';
import * as lqAction from './loopQual';
import { InHomeUtils } from './../util/inhomeUtils';
import { loaderActive } from './loder';
import { updateSCTags,tempSCData} from './../service/dtmTag';
import * as checkoutAction from './checkout';
import { updateOrderLocation } from '../service/vzdl';
import { store } from "../../src/index";/**importing store for reducer values */
import { checkIfReqiestTnEnabled } from '../containers/midnight/services/prodTileService';
import { getResumeCartDelay } from '../containers/midnight/services/prodTileService';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const resumeSavedMon = (dispatch, action) => {
    dispatch({ type: XPSEntry.resumeSavedMon, value: action });
};

export const updateLQFromXPSEntry = (dispatch, action) => {
    dispatch({ type: XPSEntry.updateLQFromXPSEntry, value: action });
};

export const resumeMonErr = (status, dispatch) => {
    dispatch({ type: XPSEntry.resumeMonErr, value: status })
};

export const incorrectMonErr = (status, dispatch) => {
    dispatch({ type: XPSEntry.incorrectMonErr, value: status })
};

export const updateEmailMTnSecStatus = (dispatch, value) => {
    dispatch({ type: XPSEntry.showMTNEmailSec, value: value })
};
export const updateCaptcha = (dispatch, valueToDispatch) => {
    dispatch({ type: XPSEntry.xpsCaptchaChanged, value: valueToDispatch });
}
export const showCaptchaLBOFromVisitId = (dispatch, showCaptchaFromVisitId,showLBOFromVisitId ) => {
    dispatch({ type: XPSEntry.xpsShowCaptchaLBOFromVisitId,   showCaptchaFromVisitId , showLBOFromVisitId  });
}

export const retrieveSmartCartXps = (dispatch, visitId, retrieveValue, lqState, buildProductState, saveState,cart,firstBill, retrieveType, retrieveSource,cmpId,encryptToken, isRetry = false, xpsState) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "Inside retrieveSmartCartXps", PAGEACTIVITY.UA));
        let isRetrieveSuccess = false; let isApiCallSuccess = false;let isCartRetrieved = false;        
        let isCreditCheckCompleted = false; let isPersonalInfo = false;
        let isRetrieveMtnOrEmail = false; let isMTN = false;
        let qString = 'RETRIEVECART-SYSTEMERROR';
        let errorMessage = 'RETRIEVECART-SYSTEMERROR';
        let isCartRetrievedFalse = false; let isAddressLineEmpty = false;  
        let closingAgencyId = sessionStorage?.getItem('closingAgencyId');    
        let url = apiUrl().retrieveSmartCart;
        let isKioskOrder = sessionStorage?.getItem('fiosReferralFlow') ? true : false;
        console.log("isKioskOrder",isKioskOrder);
        const enableVzFwdNCResumeCartFlow = lqState?.runtimeKey?.enableVzFwdNCResumeCartFlow &&  lqState?.runtimeKey?.enableVzFwdNCResumeCartFlow==='Y';
        if (InHomeUtils.isNotNull(retrieveSource) && InHomeUtils.isNotEmpty(retrieveSource) && retrieveSource.toLowerCase() === "chat" && InHomeUtils.isNotNull(encryptToken) && InHomeUtils.isNotEmpty(encryptToken)) {
            url += '?from=chat&token=' + encryptToken;
        }
        else if(InHomeUtils.isNotNull(retrieveSource) && InHomeUtils.isNotEmpty(retrieveSource) && (retrieveSource.toLowerCase() === "rtci" || retrieveSource.toLowerCase() === "wireless") && InHomeUtils.isNotNull(retrieveValue) && InHomeUtils.isNotEmpty(retrieveValue)){
            url +='?from='+ retrieveSource + '&mon=' + retrieveValue + '&isKioskOrder=' + isKioskOrder;
        }
        else {
            url +='?mon=' + retrieveValue + '&closingAgencyId=' +  closingAgencyId + '&isKioskOrder=' + isKioskOrder;
        }
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '&isMnFlow=Y';
        }
        const agencyID = new URLSearchParams(window?.location?.search)?.get?.('agency');
        if(agencyID !== null && agencyID !== undefined){
          url = url + '&agency='+agencyID
        }
        try{
            //Send my cart number for email or MTN
            if (InHomeUtils.isNotEmpty(retrieveType)) {
                if (retrieveType === XPSEntry.retrieveByMtn) {
                    url = apiUrl().retrieveSmartCart + '?mtn=' + retrieveValue;
                    isRetrieveMtnOrEmail = true;
                    isMTN= true;
                } else if (retrieveType === XPSEntry.retrieveByEmail) {
                    url = apiUrl().retrieveSmartCart + '?email=' + retrieveValue;
                    isRetrieveMtnOrEmail = true;
                    isMTN = false;
                }
            }
        }
        catch (ex) {
            catchJSException('xpsEntry', visitId, 'action-retrieveSmartCartXps-retrieveType', ex);
        }

        if (!isRetry) {
            if (InHomeUtils.isNotNull(xpsState) && InHomeUtils.isNotEmpty(xpsState.showLoaderOnSCPageStart)&& xpsState.showLoaderOnSCPageStart!== "COMPLETED") {
                xpsState.showLoaderOnSCPageStart = "COMPLETED";
                dispatch({ type: XPSEntry.showLoaderOnSCPageStart, value: "COMPLETED" });
                dispatch({
                    type: 'LOADER_ACTIVE',
                    value: { isLoaderActive: false, isLoaderText: "", isLoaderImg: "loader" }
                });                
            }
            dispatch({
                type: 'LOADER_ACTIVE',
                value: { isLoaderActive: true, isLoaderText: "Resuming your cart", isLoaderImg: "loader" }
            }); 
        }
        if (InHomeUtils.isNotNull(cmpId) && InHomeUtils.isNotEmpty(cmpId)) {
            url += '&CMP=' + cmpId;
        }        
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "Triggering retrieveSmartCartXps API and URL Is:" + url, PAGEACTIVITY.UA)); 
        const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
        if (isFiOSFlag) {
            sessionStorage.setItem("longDurationAPI", "on");
        }

        api(url, 'GET', '').then(response => {
            let isMultiLineLbo = false;
            const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
            if (isFiOSFlag) {
                if (response?.data) {
                    if (response?.data && !response?.data?.addressLine1) {
                        logToKibanna(`FiosReferral:retrievesmartcart:mon:${retrieveValue}:error:addressline1:${response?.data?.addressLine1}`, "INFO");
                    }
                    if (response?.data && response?.data?.statusMessage && (response?.data?.statusMessage.includes("is invalid") || response?.data?.statusMessage.includes("MON info is not"))) {
                        logToKibanna(`FiosReferral:retrievesmartcart:mon:${retrieveValue}:error:statusMessage:${response?.data?.statusMessage}`, "INFO");
                    }
                }
                sessionStorage.setItem("longDurationAPI", "off");
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)) {
                isApiCallSuccess = true;
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "Retreive Response Success", PAGEACTIVITY.UA));
                const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow');
                dispatch({ type: XPSEntry.retrieveSmartCart, value: response.data});
                if((!isRetrieveMtnOrEmail || (isRetrieveMtnOrEmail && isFiOSFlag)) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data.mon)){
                    dispatch({ type: XPSEntry.resumeSavedMon, value: response?.data?.mon?.toUpperCase() });
                }
                if(enableVzFwdNCResumeCartFlow && response?.data?.enrollmentNumber && response?.data?.enrollmentNumber?.length > 0){
                    dispatch({ type: 'SET_VZF_STATUS', value: true });
                    dispatch({ type: 'SET_VZFWD_ID', value: response?.data?.enrollmentNumber });
                }
                if (response?.data?.promoCodeSavedatOSI && response?.data?.promoCodeSavedatOSI === "true") {
                    saveState = {
                        ...saveState,
                        retrieveSmartCart: {
                            promoCodeSavedatOSI: true
                        }
                    }
                }
                const streamlineRCAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.isStreamlineRC;

                if(streamlineRCAEM && streamlineRCAEM ==='Y' && response?.data?.streamlineflow === "Y"){
                    if(streamlineRCAEM && streamlineRCAEM ==='Y'){
                        dispatch({type: 'SET_STREAMLINE_LQ', value: true});
                        window.sessionStorage.setItem('widgetLQHost', 'Streamline_F');
                    dispatch({ type: 'SET_RC_STREAMLINE', value: true });
                    if(window && window.sessionStorage){
                        let urlParams = new URLSearchParams(window?.location?.search);
                        if(urlParams && urlParams.get("XpsSource") !== "lq2"){
                            window.sessionStorage.setItem("strcEmailFlow",true);
                        }

                        window.sessionStorage.setItem("strc",response?.data?.streamlineflow);
                    }
                }
                else{
                    dispatch({ type: 'SET_RC_STREAMLINE', value: true });
                    if(window && window.sessionStorage){
                        window.sessionStorage.setItem("strc","N");
                    }
                }
                }

                
                if (isFiOSFlag && response?.data?.outletLocationId) {
                    sessionStorage.setItem("orderLoc", response?.data?.outletLocationId);
                    updateOrderLocation(response?.data?.outletLocationId);
                }

                if (isRetrieveMtnOrEmail && !isFiOSFlag) {
                    isRetrieveSuccess = true;
                    resumeMonErr(false, dispatch);                    
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "xpsRetrieve Source: true", PAGEACTIVITY.UA));
                    if (response?.data?.cartRetrieved && InHomeUtils.isNotEmpty(response?.data?.mon)) {
                        xpssendSmsOrEmail(visitId, dispatch, response.data.mon, retrieveValue, isMTN, xpsState.sendSmsorEmailErrAttempts)
                        updatSendSmsorEmailErr(dispatch, false);
                    } else {
                        updatSendSmsorEmailErr(dispatch, true);
                    }
                }
                else if (response.data.cartRetrieved) {
                    isCartRetrieved = true;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "Cart Retrieve - Success", PAGEACTIVITY.UA));
                    if (response.data.isLBO === "Y") {
                        isMultiLineLbo = true;
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', PAGEACTIVITY.MSG.showLBO, PAGEACTIVITY.UA));
                        errorAction("LBO", "BuildProduct", "UNSUPPORTED", "", visitId, dispatch, true, "UNSUPPORTED");
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    } else{
                        if (saveState && saveState.loadTNForSCResume === '') {
                            if (checkIfReqiestTnEnabled(lqState) === true) {
                                console.log("xpsEntry: retrieveSmartCartXps enableTnReq checkIfReqiestTnEnabled:true");
                                loadTNForSmartCartResume(visitId, dispatch, saveState);
                            }
                            else {
                                console.log("xpsEntry: retrieveSmartCartXps enableTnReq is N checkIfReqiestTnEnabled:false");
                                // loadTNForSmartCartResume(visitId, dispatch, saveState);
                            }
                        }
                        if (response.data.creditCheckCompleted) {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', PAGEACTIVITY.MSG.CCCompleted, PAGEACTIVITY.UA));
                            isCreditCheckCompleted = true;
                        }
                        if (response.data.personalInfo) {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', PAGEACTIVITY.MSG.personalInfoCompleted, PAGEACTIVITY.UA));
                            isPersonalInfo = true;
                        }
                        if (InHomeUtils.isNotNull(response.data.couponTokenResponse) && InHomeUtils.isNotNull(response.data.couponTokenResponse.companyToken) && response.data.couponTokenResponse.companyToken !== "") {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', PAGEACTIVITY.MSG.couponInfoExists, PAGEACTIVITY.UA));
                            dispatch({ type: CheckLQ.updateCouponFlowType, value: response?.data?.couponTokenResponse?.flowType });
                        }
                        if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.hoaFlag) && InHomeUtils.isNotEmpty(response.data.hoaFlag) && response.data.hoaFlag.toUpperCase()=== "Y") {
                            dispatch({ type: HOAFlow.onHoaFlowCreation, value: true })
                            lqState.hoaFlowDetails = {isHoaFlow : true};
                        }
    
                        if (InHomeUtils.isNotEmpty(response.data.addressLine1) && InHomeUtils.isNotEmpty(response.data.addressLine2)) {
                            isRetrieveSuccess = true;
                            if(isFiOSFlag && isRetrieveMtnOrEmail) {
                                resumeMonErr(false, dispatch);                    
                                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "xpsRetrieve Source: true", PAGEACTIVITY.UA));
                                if (response.data.cartRetrieved && InHomeUtils.isNotEmpty(response.data.mon)) {
                                    xpssendSmsOrEmail(visitId, dispatch, response.data.mon, retrieveValue, isMTN, xpsState.sendSmsorEmailErrAttempts)
                                    updatSendSmsorEmailErr(dispatch, false);
                                    //AEm controlled delay for resume cart
                                    // if(InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.ResumeCartDelay)){
                                    //     setTimeout(function () {
                                    //         dispatch({
                                    //             type: 'LOADER_ACTIVE',
                                    //             value: { isLoaderActive: true, isLoaderText: "Resuming your cart", isLoaderImg: "loader" }
                                    //         }); 
                                    //         updateLQDetailsXps(dispatch, response.data, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, isFiOSFlag, isRetrieveMtnOrEmail);
                                    //     }, lqState.runtimeKey.ResumeCartDelay);
                                    // }else{
                                        setTimeout(function () {
                                            dispatch({
                                                type: 'LOADER_ACTIVE',
                                                value: { isLoaderActive: true, isLoaderText: "Resuming your cart", isLoaderImg: "loader" }
                                            }); 
                                            updateLQDetailsXps(dispatch, response.data, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, isFiOSFlag, isRetrieveMtnOrEmail);
                                         }, getResumeCartDelay(lqState));
                                    // }
                                
                                } else {
                                    updatSendSmsorEmailErr(dispatch, true);
                                }
                            }
                            else {
                                if(enableVzFwdNCResumeCartFlow && response?.data?.enrollmentNumber && response?.data?.enrollmentNumber?.length>0){
                                    let urlParams = new URLSearchParams(window?.location?.search);
                                    if(urlParams && urlParams.get("XpsSource") === "lq2" && urlParams.get("VFEnrollmentSuccess")==="Y"){
                                        const requiredData = {
                                            lqState: lqState,
                                            buildProductState: buildProductState,
                                            saveState: saveState,
                                            cart: cart,
                                            retrievCartData: response?.data,
                                            firstBill: firstBill,
                                            retrieveSource: "direct",
                                            cmpId: null,
                                            isCreditCheckCompleted: isCreditCheckCompleted,
                                            isPersonalInfo: isPersonalInfo
                                          }
                                        getVZFwdEnrollmentDetails(response?.data?.enrollmentNumber, visitId, dispatch, requiredData)
                                    }
                                    else{
                                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false }});
                                    }
                                }
                                else{
                                    //AEm controlled delay for resume cart
                                    // if(InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.ResumeCartDelay)){
                                    //     setTimeout(function () {
                                    //         updateLQDetailsXps(dispatch, response.data, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId);
                                    //     }, lqState.runtimeKey.ResumeCartDelay);
                                    // }else{
                                        setTimeout(function () {
                                            updateLQDetailsXps(dispatch, response.data, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId);
                                        }, getResumeCartDelay(lqState));
                                }
                            }
                        }else{
                            isAddressLineEmpty = true;
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "ADDRESSDETAILS-EMPTY", PAGEACTIVITY.UA));
                        }
                    }
                }
                else if (!response?.data?.cartRetrieved){
                    isCartRetrievedFalse = true;
                    const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
                    if(fiosReferral === "true"){
                        incorrectMonErr(true, dispatch);   
                    }
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', PAGEACTIVITY.MSG.retrieveFailedCart, PAGEACTIVITY.UA));
                }
            }
            else if (!isRetry) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', "Retrieve Cart - ReAttempt", PAGEACTIVITY.UA));
                retrieveSmartCartXps(dispatch, visitId, retrieveValue, lqState, buildProductState, saveState,cart,firstBill, retrieveType, retrieveSource,cmpId,encryptToken, true,xpsState);
            }            
            if (!isMultiLineLbo && (isApiCallSuccess||isRetry) && (!isCartRetrieved || !isRetrieveSuccess)) {
                if(!isRetrieveMtnOrEmail) {
                    resumeMonErr(true, dispatch);
                    if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data.mon)){
                        dispatch({ type: XPSEntry.resumeSavedMon, value: response.data.mon.toUpperCase() });
                    }
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

                let apiError = "";
                if (InHomeUtils.isNull(response)) {
                    errorMessage += '-ResponseNull';
                } else {
                    if (InHomeUtils.isNull(response.data)) {
                        errorMessage += '-DataNull';
                    } else {
                        if (InHomeUtils.isNotNull(response.data.statusCode)) {
                            errorMessage += '-' + response.data.statusCode;

                            if (InHomeUtils.isNotNull(response.data.statusMessage)){
                                let statusMessage = response.data.statusMessage;
                                if(statusMessage.indexOf('Smart cart has been expired') !== -1){
                                    errorMessage += '-expired';
                                    qString = 'RETRIEVECART-PURGED';
                                }
                                else if(statusMessage.indexOf('Smart Cart is invalid') !== -1){
                                    errorMessage += '-invalid';
                                    qString = 'RETRIEVECART-PURGED';
                                }else if(statusMessage.indexOf('Missing Mon element or Mon Info is not available') !== -1){
                                    errorMessage += '-missing';
                                }else if(statusMessage.indexOf('Requested MON info is not available') !== -1){
                                    errorMessage += '-notavailable';
                                }                                
                            }
                        }

                        if (isAddressLineEmpty) {
                            errorMessage += '-AddressEmpty';
                        }
                    }

                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta)) {
                        if(InHomeUtils.isNotNull(response.meta.code)){
                            errorMessage += '-' + response.meta.code;
                        }
                        
                        if (InHomeUtils.isNotNull(response.meta.description)){
                            apiError = response.meta.description;
                        }
                    }
                }

                if(isCartRetrievedFalse){
                    if(InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y"){
                        dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
                    }
                    else if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.hoaFlag) && InHomeUtils.isNotEmpty(response.data.hoaFlag) && response.data.hoaFlag.toUpperCase()=== "Y") {
                        errorAction("LBO", "ResumeCart", "HOA", "", visitId, dispatch, true, "HOA");
                    }                    
                }else if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                    dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
        .catch(error => {
            const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
        if (isFiOSFlag) {
            logToKibanna(`FiosReferral:retrievesmartcart:mon:${retrieveValue}:error:${error?.message} `, "INFO");
            sessionStorage.setItem("longDurationAPI", "off");
        }
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:retrieveSmartCartXps,errorMessage:${error.message}`;
            logKafka("ERROR", "RETRIEVESMARTCARTXPS", errorMsg, getErrorLogUrl, "applogs", visitId);
            resumeMonErr(true, dispatch);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'retrieveSmartCartXps', errorMsg, PAGEACTIVITY.UA));

            if (InHomeUtils.isNotEmpty(error.message)) {
                errorMessage += '-exception-' + error.message;
            }

            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-retrieveSmartCartXps', ex);
    }
};

export const updateLQDetailsXps = (dispatch, lqResponse, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, isFiOSFlag, isRetrieveMtnOrEmail) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateLQDetailsXps', "Inside updateLQDetailsXps", PAGEACTIVITY.UA));
        let isAddressAvailable = false;
        if (InHomeUtils.isNotNull(lqResponse)) {
            if (InHomeUtils.isNotEmpty(lqResponse.addressLine1) && InHomeUtils.isNotEmpty(lqResponse.addressLine2)) {
                let addressLine1 = lqResponse.addressLine1;
                let addressLine2 = lqResponse.addressLine2;                
                const addressValue2 = addressLine2.trim().split(' ');
                let zip = addressValue2 && addressValue2.length && addressValue2.pop() || ''; 
                let state = addressValue2 && addressValue2.length && addressValue2.pop() || '';
                let city =  addressValue2 && addressValue2.length && addressValue2.reduce((final,current) => current = final.concat(' ', current ),'').trim() || ''; 
                let altcity = city.concat('');
                let addressID = lqResponse.addressID || '';

                if (city !== "" && altcity !== "" && state !== "" && zip !== "") {
                    let zipcodeSelected = { zip: zip, city: city, altCity: altcity, state: state };
                    dispatch({ type: 'LQ_ON_ZIPCODE_SELECTED', value: zipcodeSelected });
                    lqState.selectedState=zipcodeSelected;
                }
                if (addressID !== "" && addressLine1 !== "" && city !== "" && state !== "") {
                    isAddressAvailable = true;
                    let streetAddress =
                    {
                        value: {
                             addressID, baseAddID: '0', street: addressLine1, elkStreet: addressLine1, city, state
                        }, displayValue: addressLine1
                    };
                    let streetAddressSelected =
                    {
                        streetAddr: {
                            addressID: addressID, baseAddID: '0', street: addressLine1, elkStreet: addressLine1,
                            city, state
                        },
                        isdisplayUnit: false
                    };
                    dispatch({ type: 'LQ_ON_STREETADDR_CHANGE', value: streetAddress });
                    dispatch({ type: 'LQ_ON_STREETADDR_SELECTED', value: streetAddressSelected });
                    lqState.selectedAdr=streetAddressSelected;
                    lqState.streetAddrs=streetAddress
                    const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
                    const supressResumeCartCall = fiosReferral === "true" ? true : false
                    if(supressResumeCartCall) {
                        const urlParams = new URLSearchParams(window?.location?.search);
                        const mode = urlParams.get('mode')
                        if(mode === 'dev'){
                            //const mon = lqResponse.mon ?? "";
                            //const page = `${Pages.ResumeCart}?xpsid=${mon}&Source=Referral`
                            //redirectTo(page, dispatch);
                            resumeSmartCartXps(dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, false, false, isFiOSFlag, isRetrieveMtnOrEmail);
                        } else {
                            resumeSmartCartXps(dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, false, false, isFiOSFlag, isRetrieveMtnOrEmail);
                            //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        }

                    } else {
                        resumeSmartCartXps(dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId);
                    }
                }
            }else{
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateLQDetailsXps', "address details are Empty", PAGEACTIVITY.UA));
            }
        }else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateLQDetailsXps', "address details are Empty", PAGEACTIVITY.UA));
        }

        if (!isAddressAvailable) {
            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                dispatch({ type: 'UPDATE_LBO',  value: 'UPDATECART-SYSTEMERROR-AddressEmpty' });
                errorAction("LBO", "ResumeCart", "UPDATECART-SYSTEMERROR-AddressEmpty", "applogs", visitId, dispatch, true, 'UPDATECART-SYSTEMERROR');
            }
        }
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-updateLQDetailsXps', ex);
    }
}

export const resumeSmartCartXps = async (dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, isResumeCartFailed = false, isResumeFailNull = false, isFiOSFlag = false, isRetrieveMtnOrEmail = false,) => {
    let qString = 'RESUMECART-SYSTEMERROR';
    let errorMessage = 'RESUMECART-SYSTEMERROR';
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', "Inside resumeSmartCartXps", PAGEACTIVITY.UA));
        let url = apiUrl().resumeSmartCart;  
        if (InHomeUtils.isNotEmpty(retrieveSource)) {
            url += '?from=' + retrieveSource;
        }
        if (InHomeUtils.isNotNull(cmpId) && InHomeUtils.isNotEmpty(cmpId)) {
            url += '&CMP=' + cmpId;
        }
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '&isMnFlow=Y';
        }
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')) {
            url = url + '&agency=CETCORDER2';
        }
        const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow'); 
        if(isRetailFiosReferral){
            const closingAgencyId =  window.sessionStorage.getItem('closingAgencyId');
            url = url + `&closingAgencyId=${closingAgencyId}`
        }
        const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
        if (isFiOSFlag) {
            sessionStorage.setItem("longDurationAPI", "on");
        }
        api(url, 'GET', '').then(async(response) => {
            const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
            if (isFiOSFlag) {
                sessionStorage.setItem("longDurationAPI", "off");
            }
            if (isFiOSFlag && isRetrieveMtnOrEmail){
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)){
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', "ResumeSmartCart - Success", PAGEACTIVITY.UA));
                if (InHomeUtils.isNotEmpty(retrieveSource)) {
                    captureSCResumeSource(dispatch,retrieveSource,saveState,visitId);
                }
                if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.mnHAuth) && InHomeUtils.isNotEmpty(response.data.mnHAuth)){
                    dispatch({type : 'MNHSIGNUPINDICATOR',value : response.data.mnHAuth});
                }
                //Revalidate the Winback TN  for Smart Cart resume   
                if (InHomeUtils.isNotNull(response.data.winback) && response.data.winback === "Y" && InHomeUtils.isNotNull(response.data.wtn) && InHomeUtils.isNotEmpty(response.data.wtn) && response.data.wtn.length === 10) {
                    try {
                        let tnPortableCheckResp = await buildProductAction.tnPortableCheck(response.data.wtn, dispatch, visitId, false);
                        if (tnPortableCheckResp) {                           
                            if (InHomeUtils.isNotEmpty(response.data.wtn)) {
                                dispatch({ type: "RESUME_WINBACKTN", value: response.data.wtn })
                                saveState.resumeWinbackTN = response.data.wtn
                            }
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', PAGEACTIVITY.MSG.resumeWB, PAGEACTIVITY.UA));
                            dispatch({ type: "RESUME_ISWINBACK", value: true })
                            saveState.resumeIsWinback = true;
                        }

                    }
                    catch (ex) {
                        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-tnPortableCheck', ex);
                    }

                }
                if (isCreditCheckCompleted && response && response.data && response.data.depositRequired === "Y" && response.data.dataDepositAmount !== "" && response.data.dataDepositAmount > 0) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', PAGEACTIVITY.MSG.resumeDepositRequired, PAGEACTIVITY.UA));
                    dispatch({ type: CheckOut.updateDepositInfo, value: true })
                    dispatch({ type: CheckOut.updateDepositAmount, value: response.data.dataDepositAmount })
                }                
                //Advantage Offer
                if(response && response.data && InHomeUtils.isNotEmpty(response.data.vzwOffer)){
                    lqAction.updateVZWResponse(dispatch,response.data.vzwOffer)
                }
                if(response && response.data && InHomeUtils.isNotNull(response.data.rafSTNID) && InHomeUtils.isNotEmpty(response.data.rafSTNID)){
                    dispatch({ type: "RESUME_RAFSTNID", value: response.data.rafSTNID })              
                }               
                //F&F change for getting FF details during smart cart retrieve
                
                if(response && response.data && InHomeUtils.isNotNull(response.data.friendsAndFamily) && InHomeUtils.isNotEmpty(response.data.friendsAndFamily) && InHomeUtils.isNotNull(response.data.friendsAndFamily.ffCouponCode) && InHomeUtils.isNotEmpty(response.data.friendsAndFamily.ffCouponCode) && InHomeUtils.isNotNull(response.data.friendsAndFamily.ffLeadListId) && InHomeUtils.isNotEmpty(response.data.friendsAndFamily.ffLeadListId)){
                    let ffValidationInfo = {
                        ffCoupon: response.data.friendsAndFamily.ffCouponCode,
                        leadListID: response.data.friendsAndFamily.ffCouponCode.ffLeadListId,
                        ffCouponError: false,
                        ffValidationSucess: true,
                        ffValidationFailure: false,
                        ffValidationErrorType:  '', 
                        isFFCheckoutValidation: false,
                        profileDataSpeed:''
                    }
                    dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                }

                //V&P change for getting V&P details during smart cart retrieve
                
                //Visible & prePaid change
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data) && response.data.visPreCouponCode && InHomeUtils.isNotEmpty(response.data.visPreCouponCode)) {
                    let visPreCouponInfo = {
                     visPreCoupon:  response.data.visPreCouponCode,
                     leadListID: null,
                     visPreCouponError: false,
                     visPreValidationSucess: true,
                     visPreValidationFailure: false,
                     visPreValidationErrorType: '',
                     isVisPreCheckoutValidation: false,
                     isDiscountEligible: true,
                     isDiscountApplied: true
                   }
                   dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreCouponInfo });
                 }

                //VZ Connections change for getting token info during resume smart cart
                if(response && response.data && InHomeUtils.isNotNull(response.data.tokenInfo) && InHomeUtils.isNotNull(response.data.tokenInfo.companyToken) && InHomeUtils.isNotEmpty(response.data.tokenInfo.companyToken) && InHomeUtils.isNotNull(response.data.tokenInfo.customerToken) && InHomeUtils.isNotEmpty(response.data.tokenInfo.customerToken) && InHomeUtils.isNotNull(response.data.tokenInfo.tokenType) && InHomeUtils.isNotEmpty(response.data.tokenInfo.tokenType) && response.data.tokenInfo.tokenType.toLowerCase().indexOf('vzconnection') > -1){
                    let vzcCouponInfo = {
                        vzcCoupon: response.data.tokenInfo.customerToken,
                        vzcValidationSuccess: true,
                        isDiscountEligible: true
                    }
                    dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo }); 
                }                
                lqAction.isFCPflow(response.data.fcpFlow, dispatch);
                let enableceApps = lqState && lqState.runtimeKey && lqState.runtimeKey.enableceapps && lqState.runtimeKey.enableceapps.toUpperCase() === 'Y' && response.data.fcpFlow;
                buildProductState.showConnectedApps=enableceApps
                dispatch({type: 'SHOW_CONNECTED_APPS_EXP', value: enableceApps});                            
                updateQualifedServices(lqState,dispatch, response.data, visitId);
                loadCartForXPSSmartCart(visitId, dispatch, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState, lqState,cart,firstBill, false);
                            
            }
            else if (!isResumeCartFailed) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', "ResumeSmartCart-ReAttempt", PAGEACTIVITY.UA));
                resumeSmartCartXps(dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, true);
            }
            else {
                let apiError = "";

                resumeMonErr(true, dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

                if (InHomeUtils.isNull(response)) {
                    if (!isResumeFailNull)
                        resumeSmartCartXps(dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, true, true);
                    else
                        errorMessage += '-ResponseNull';
                } else {
                    if (InHomeUtils.isNull(response.data)){
                        if (!isResumeFailNull)
                            resumeSmartCartXps(dispatch, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId, true, true);
                        else
                            errorMessage += '-DataNull';
                    }

                    if (InHomeUtils.isNotNull(response.meta)) {
                        if(InHomeUtils.isNotNull(response.meta.code)){
                            errorMessage += '-' + response.meta.code;
                        }
                        if (InHomeUtils.isNotNull(response.meta.description)){
                            apiError = response.meta.description;
                        }
                    } 
                }
                
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', PAGEACTIVITY.MSG.resumeMONError + ":" + errorMessage + "-"+ apiError, PAGEACTIVITY.UA));
                
                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                    dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                    errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
                }
            }
        })
        .catch(error => {
            const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
            if (isFiOSFlag) {
                sessionStorage.setItem("longDurationAPI", "off");
            }        
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:resumeSmartCartXps,errorMessage:${error.message}`;
            logKafka("ERROR", "RESUMESMARTCARTXPS", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', errorMsg, PAGEACTIVITY.UA));

            if (InHomeUtils.isNotEmpty(error.message)) {
                errorMessage += '-exception-' + error.message;
            }
            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
            }
        });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-resumeSmartCartXps', ex);
    }
};

export const updateQualifedServices = (lqState,dispatch, lqResponse, visitId) => {

    try {        
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateQualifedServices', "Inside updateQualifedServices", PAGEACTIVITY.UA));

        let qualifedServices = { qualified: 'Y',  fiosReady: 'N', quantumEligible: 'N', fiosSelfInstall: 'N',isFCP:false,
            services: [{ servicename: 'FiOSData', qualified: 'N' }, { servicename: 'Video', qualified: 'N' }, 
                        { servicename: 'Voice', qualified: 'N' }]
        };
        let logmessage = '';
		let servicesQualified = null;

        if(InHomeUtils.isNotNull(lqResponse)){
            servicesQualified = {
                isDataQualified : true,
                isHsiQualified : false,
                isVideoQualified : true,
                isVoiceQualified : true
            }
            if(InHomeUtils.isNotNull(lqResponse.fiosData) && lqResponse.fiosData === true){
                qualifedServices.services[0].qualified = 'Y';
                servicesQualified.isDataQualified = true;
                logmessage = "DATA QUALIFIED";
            }else{
            	servicesQualified.isDataQualified = false;
                logmessage = "DATA NOT QUALIFIED";
            }
            if(InHomeUtils.isNotNull(lqResponse.fiosVideo) && lqResponse.fiosVideo === true){
                qualifedServices.services[1].qualified = 'Y';
                servicesQualified.isVideoQualified = true;
                logmessage +=  "|VIDEO QUALIFIED";
            }else{
            	servicesQualified.isVideoQualified = false;
                logmessage +=  "|VIDEO NOT QUALIFIED";
            }
            if(InHomeUtils.isNotNull(lqResponse.fiosVoice) && lqResponse.fiosVoice === true){
                qualifedServices.services[2].qualified = 'Y';
                servicesQualified.isVoiceQualified = true;
                logmessage +=  "|FIOS_VOICE QUALIFIED";
            }else{
            	servicesQualified.isVoiceQualified = false;
                logmessage +=  "|FIOS_VOICE NOT QUALIFIED";
            }

            if(InHomeUtils.isNotEmpty(lqResponse.quantumEligible) && lqResponse.quantumEligible === 'Y'){
                qualifedServices.quantumEligible = 'Y';
            }

            if(InHomeUtils.isNotEmpty(lqResponse.fiosSelfInstall) && lqResponse.fiosSelfInstall === 'Y'){
                qualifedServices.fiosSelfInstall = 'Y';
            }

            if(InHomeUtils.isNotEmpty(lqResponse.fiosReady) && lqResponse.fiosReady === 'Y'){
                qualifedServices.fiosReady = 'Y';
                logmessage +=  "|FIOSREADY"
            } 
            
            if(InHomeUtils.isNotNull(lqResponse.fcpFlow) && lqResponse.fcpFlow){
                qualifedServices.isFCP = lqResponse.fcpFlow;
            }
        }
        
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateQualifedServices', logmessage, PAGEACTIVITY.UA));
        dispatch({ type: "LQ_ON_CHECK_AVAILABILITY_CLICK", value: qualifedServices });      
        dispatch({ type: 'LQ_SET_QUALIFIED_SERVICES', value: servicesQualified });
        // retrieveQualdetails Satellite Questionnaire 
        try {           
            let retrieveQualdetailsUrl = apiUrl().retrieveQualdetails;
            let errMsg = ""; let stat = "";
            api(retrieveQualdetailsUrl, 'GET', '').then(response => { 
                if (InHomeUtils.isNull(response) || response === "") {
                    errMsg = "SmartCart-RetrievequalResponseNull";
                } 
                if(response.data?.getBroadbandAvailabilityResult?.fttpAvailabilityDetailsAGR?.isRuralBroadBandAddress){
                    dispatch({ type: 'IS_RURAL_BROADBAND_ADDRESS', value: true });
                }                      
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: response.data });
                    lqState.lqQualdetails= response.data;
                    if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)
                        && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent) && response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent === "Y") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'smartcart_RetrieveQual', "IONT Eligible", PAGEACTIVITY.UA));
                        dispatch({ type: "IONT_ELIGIBLE", value: true })
                        dispatch({ type: "IONT_STATUS", value: true })
                        tempSCData.IONTEligible = true;
                        lqState.iONTEligible=true;
                    }
                }
                else {                    
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && (response.meta.code))
                        stat = response.meta.code;
                    
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                        errMsg = response.message;
                        if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                            stat = response.response.status;
                    }
                    if (errMsg !== "" || stat !== "")
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'smartcart_RetrieveQual', PAGEACTIVITY.MSG.lqError + "-" + errMsg + " - " + stat, PAGEACTIVITY.UA));
                }
            })

        }
        catch (ex) {

            catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-retrieveQualdetailsCheck', ex);
        }
         
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-updateQualifedServices', ex);
    }
}

const filterFiosFiveBasicChannels = (lstChannels, prodId) => {
    let lstMatchedChannel = [];

    if (prodId) {
        prodId = prodId.toUpperCase();
        lstMatchedChannel = lstChannels.filter((el) => {
            return (el.id.toUpperCase().indexOf(prodId) !== -1)
        });
    }
    return lstMatchedChannel;
};

// Resumecartflow fisofiveselected channels issue fix
const formatSelectedFiosFiveChannels = (cartDataChannels) => {
    cartDataChannels = cartDataChannels.map(val =>{
        val.id = val.id || val.prodId;
        val.name = val.name || val.prodName;
        val.logo = val.logo || val.id+'.png';
        return val;
        }).filter(item => {
           // prodType: 'BASIC_FF', //Todo
           let prodTypeVal = item.prodTypeVal ? item.prodTypeVal.trim(): ''
            return prodTypeVal.toLowerCase() !== "musthavea" && prodTypeVal.toLowerCase() !== "musthaveb";
        });
        return cartDataChannels;
}

export const loadCartForXPSSmartCart = (visitId, dispatch, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,lqState,cart,firstBill, isLoadCartFailed = false, isLoadCartFailNull =false) => {
    let qString = 'LOADCART-SYSTEMERROR';
    let errorMessage = 'LOADCART-SYSTEMERROR';
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "Inside loadCartForXPSSmartCart", PAGEACTIVITY.UA));
        let getCart = apiUrl().getCartAcc + '/' + visitId;
        let status = ''; let errorMsg = '';
        let voiceProduct=null;
        const redirecttoOSIPromoCodeScenerio = saveState?.retrieveSmartCart?.promoCodeSavedatOSI; 
        api(getCart, 'GET', '').then(response => {
            if (InHomeUtils.isNull(response)) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', PAGEACTIVITY.MSG.retrieveCartResponseEmptyorNull, PAGEACTIVITY.UA));
            }else {
                if(InHomeUtils.isNull(response.data)) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', PAGEACTIVITY.MSG.retrieveCartDataNull, PAGEACTIVITY.UA));
                }

                if(InHomeUtils.isNotNull(response.meta)){
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "META VALUE:" + response.meta.code, PAGEACTIVITY.UA));
                }
            }
            
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)) {
                if (InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered) && response.data.orderDetail.servicesOrdered !== '') {
                    
                    try {

                        if (InHomeUtils.isNotEmpty(response.data.vcpestbQty)){
                            dispatch({ type: 'UPDATE_VCPE_STB_Qty', value: response.data.vcpestbQty });
                        }

                        if (InHomeUtils.isNotNull(response.data.atvQual) && response.data?.atvQual == true){
                            dispatch({type : 'ANDROID_TV_STB',value : true})
                        }
                        else{
                            dispatch({type : 'ANDROID_TV_STB',value : false})
                        }
                        
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "loadCartForXPSSmartCart Response - Success", PAGEACTIVITY.UA));

                        if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && response.data.cartTierPricing.tierContent.length > 0) {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));

                            if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections)
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section) && response.data.cartTierPricing.tierContent[0].sections.section.length > 0
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections) && response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.length > 0) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, PAGEACTIVITY.UA));
                            }
                        }
                        else {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "CART TIER CONTENT EMPTY", PAGEACTIVITY.UA));
                        }

                    }
                    catch (ex) {
                        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', ex);
                    }
                    
                    try {
                        if (InHomeUtils.isNotNull(response.data.cartTierPricing)){
                            let cartDataOnResume = getCartDataDefault();
                            cartDataOnResume = getCartData(response.data.cartTierPricing.tierContent, visitId);
                            
                            dispatch({
                                type: "UPDATE_CART",
                                value: {
                                    cartResponse: response.data.cartTierPricing,
                                    cartHeader: getCartHeader(response.data.cartTierPricing.tierContent,visitId),
                                    cartData: cartDataOnResume,
                                    cartOrderDetail: response.data.orderDetail
                                }
                            });

                            /* Disney perk promo changes -- planned during Oct 7th, 2024 to Nov 6th, 2024
                                For disney perk promo changes
                                */
                            if(response?.data?.cartTierPricing?.tierContent?.length > 0) {
                                const promoSection = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(p => p?.sectionName === CartServices.Promotions);
                                const offers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'Offers');
                                    let disneyPromoEligible = false;
                                    offers?.promos?.forEach(promo => {
                                        if(promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_TRACKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_MARKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT') {
                                            disneyPromoEligible = true;
                                        }
                                    });
                                dispatch({ type: 'DISNEY_PROMO_PRESENT', value: disneyPromoEligible });
                            }

                            if (InHomeUtils.isNotNull(cartDataOnResume) && InHomeUtils.isNotNull(cartDataOnResume[0]) 
                            && InHomeUtils.isNotNull(cartDataOnResume[0].fiosFiveSelectedChannels) && cartDataOnResume[0].fiosFiveSelectedChannels.length > 0) {
                                let cartDataChannels = [];
                                if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveBasicChannels) && buildProductState.tv.fiosFiveBasicChannels.length > 0) {
                                    cartDataOnResume[0].fiosFiveSelectedChannels.forEach((item) => {
                                        let matchesFound = filterFiosFiveBasicChannels(buildProductState.tv.fiosFiveBasicChannels, item);
                                        if (matchesFound && matchesFound.length) {
                                            cartDataChannels.push(matchesFound[0]);
                                        }
                                    })

                                    if(cartDataChannels.length >0){
                                        cartDataChannels = formatSelectedFiosFiveChannels(cartDataChannels);
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                    }else{
                                        cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                    }
                                }else{
                                    cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                }
                            }
                            
                            if (InHomeUtils.isNotNull(cart) ) {
                                cart.cartResponse=response.data.cartTierPricing;
                                cart.cartHeader= getCartHeader(response.data.cartTierPricing.tierContent,visitId);
                                cart.cartData= cartDataOnResume;
                                cart.cartOrderDetail=response.data.orderDetail;
                            }
                        }
                    }
                    catch (ex) {
                        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', ex);
                    }

                    try {
                        voiceProduct = getSelectedVoice(response.data.cartTierPricing, visitId);
                        if (InHomeUtils.isNotNull(saveState) && InHomeUtils.isNotNull(saveState.resumeIsWinback) && !saveState.resumeIsWinback) {                            
                            if (!saveState.isTNUpdatedForResumeSmartCart && InHomeUtils.isNotNull(voiceProduct) && InHomeUtils.isNotEmpty(saveState.loadTNForSCResume)) {
                                let tn = saveState.loadTNForSCResume;
                                if (tn !== "" && tn !== "1000000001" && tn !== "9999999999") {
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateRequestTNForFDV', "Triggering updateRequestTNForFDV", PAGEACTIVITY.UA));                                                                       
                                    buildProductAction.updateRequestTNForFDV(visitId, tn, dispatch);
                                }
                            }
                        }
                    }
                    catch (ex) {
                        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', ex);
                    }

                    let cartProducts = (InHomeUtils.isNotNull(response.data.cartTierPricing)) ? getCartProducts(response.data.cartTierPricing,visitId) : null;
                    let contract = '';
                    let resumeFlowType = 'Resume';
                    if (InHomeUtils.isNotNull(response.data.orderDetail)) {
                        if(InHomeUtils.isNotNull(response.data.orderDetail.contract)){
                            contract = response.data.orderDetail.contract;
                        }
                        if(InHomeUtils.isNotNull(response.data.orderDetail.bundleId) && response.data.orderDetail.bundleId === 'B0038'){
                            resumeFlowType = 'FCPResume';
                        }
                    }
                    preselectCartProductsForSCResume(cartProducts,voiceProduct,dispatch,visitId, resumeFlowType, buildProductState,lqState,saveState,cart,firstBill);
                    buildProductAction.getSpecialOffers(visitId, contract, dispatch);
                    buildProductAction.fetchOfferInCart(visitId, cartProducts, dispatch, contract,null,null,null,false,lqState);

                    //fetch all banners and store
                    if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotEmpty(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey) && lqState.runtimeKey.BFHoliday2021 && (lqState.runtimeKey.BFHoliday2021 === 'BF' || lqState.runtimeKey.BFHoliday2021 === 'H' )) {
                        //lqAction.updateBannerType(BannerTypes.BlackFriday2020, dispatch);
                    }else{
                    lqAction.updateBannerType(BannerTypes.ResumeCart, dispatch)
                    }
                    lqAction.fetchBanners(dispatch, visitId);
                    lqAction.fetchFlashOfferDetails(dispatch, visitId);

                    dispatch({ type: Save.issmartcartFlow, value: true });
                    const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
                    let isUnSupportedAvailable = getUnsupportedProducts(response.data, dispatch, visitId);
                    let isDisableUnSupported = (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.DisableUnSupported) && lqState.runtimeKey.DisableUnSupported === "Y") ? true: false;
                    const isRetailFiosReferralCheck = window.sessionStorage.getItem('fiosReferralFlow');
                    const xpsSourceReferralFlowCheck = window.sessionStorage.getItem('xpsSourceReferralFlow');
                    if (isUnSupportedAvailable && isDisableUnSupported) {
                        let errorMsg = `MethodName:loadCartForXPSSmartCart,errorMessage:Non Supported Products`;                        
                        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                        logKafka("ERROR", "LOADCARTFORXPSSMARTCART", errorMsg, getErrorLogUrl, "applogs", visitId);
                        errorAction("LBO", "ResumeCart", "UNSUPPORTED", "", visitId, dispatch, true, "UNSUPPORTED");
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', errorMsg, PAGEACTIVITY.UA));
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                    else if ((isRetailFiosReferralCheck !== 'true' && xpsSourceReferralFlowCheck !== 'true') && (isCreditCheckCompleted || isPersonalInfo) || (isCreditCheckCompleted && isPersonalInfo)) {
                    // else if ( isPersonalInfo) {
                        if(InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.DisableResumeCheckout) && lqState.runtimeKey.DisableResumeCheckout ==="Y"){
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', PAGEACTIVITY.MSG.redirectToBuildProducts, PAGEACTIVITY.UA));
                            
                            const page = isRetailFiosReferral ? `${Pages.BuildProduct}?fiosReferral=Y` : redirecttoOSIPromoCodeScenerio ? Pages.orderSummary :  Pages.BuildProduct
                             redirectTo(page, dispatch);
                        }
                        else{
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', PAGEACTIVITY.MSG.redirectToCheckout, PAGEACTIVITY.UA));
           
                            
                            if(isRetailFiosReferral){
                                lqAction.updateRuntimeKeys(dispatch,'resume');
                            }
                            
                            buildProductAction.updateCheckoutBtnStatus(true, dispatch)
                            checkoutAction.doValidateCart(visitId, dispatch,"Checkout","","",buildProductState);
                            checkoutAction.checkSatelliteEligible(dispatch, lqState.lqQualdetails, visitId);                            
                            //redirectTo(Pages.Checkout, dispatch);
                            
                            
                        }
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', PAGEACTIVITY.MSG.redirectToBuildProducts, PAGEACTIVITY.UA));
                        const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
                        const isStreamlineFLow = window.sessionStorage.getItem('strc')? window.sessionStorage.getItem('strc') : 'N';
                        //const isStreamlineFLow = "Y";
                        const page = isStreamlineFLow === "Y" ? Pages.StreamLine :isRetailFiosReferral ? `${Pages.BuildProduct}?fiosReferral=Y` : redirecttoOSIPromoCodeScenerio ? Pages.orderSummary : Pages.BuildProduct
                        redirectTo(page, dispatch);
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', PAGEACTIVITY.MSG.cartEmpty + "-" + PAGEACTIVITY.MSG.redirectToBuildProducts, PAGEACTIVITY.UA));
                    dispatch({ type: Save.issmartcartFlow, value: false });
                    clearCart(visitId);
                    const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
                    //const isStreamlineFLow = "Y";
                    const isStreamlineFLow = window.sessionStorage.getItem('strc')? window.sessionStorage.getItem('strc') : 'N';
                    const page = isStreamlineFLow === "Y" ? Pages.StreamLine :isRetailFiosReferral ? `${Pages.BuildProduct}?fiosReferral=Y` :redirecttoOSIPromoCodeScenerio ? Pages.orderSummary : Pages.BuildProduct
                redirectTo(page, dispatch);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }); 
                }
            }
            else if (!isLoadCartFailed) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "loadCartForXPSSmartCart-ReAttempt", PAGEACTIVITY.UA));
                loadCartForXPSSmartCart(visitId, dispatch, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,lqState,cart,firstBill, true);
            }
            else {
                let apiError = "";
               
                if (InHomeUtils.isNull(response)) {
                    if (!isLoadCartFailNull) 
                        loadCartForXPSSmartCart(visitId, dispatch, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,lqState,cart,firstBill, true,true);
                    else
                        errorMessage += '-ResponseNull';
                } else {
                    if (InHomeUtils.isNull(response.data)){
                        if (!isLoadCartFailNull) 
                            loadCartForXPSSmartCart(visitId, dispatch, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,lqState,cart,firstBill, true,true);
                        else
                            errorMessage += '-DataNull';
                    }

                    if (InHomeUtils.isNotNull(response.meta)) {
                        if(InHomeUtils.isNotNull(response.meta.code)){
                            errorMessage += '-' + response.meta.code;
                        }
                        if(InHomeUtils.isNotNull(response.meta.description)){
                            apiError = response.meta.description;
                        }
                    }
                }
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "RESPONSE FAILED:" + errorMessage + "-" + apiError, PAGEACTIVITY.UA));

                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                    errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
                }
            }           
        })
        .catch(error => {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForXPSSmartCart', "Exception Is:" + error.message, PAGEACTIVITY.UA));
            
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

            if (InHomeUtils.isNotEmpty(error.message)) {
                errorMessage += "-exception-" + error.message;
            }
            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
            }
        });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-loadCartForXPSSmartCart', ex);
    }
};

export const xpssendCartNum = (dispatch, action) => {
    dispatch({ type: XPSEntry.sendCartNum, value: action });
}

export const updatSendSmsorEmailErr = (dispatch, action) => {
    dispatch({ type: XPSEntry.sendSmsorEmailErr, value: action });
}

export const xpssendSmsOrEmail = (visitId, dispatch, mon, smsOrEmail, isMtn, sendSmsorEmailErrAttempts) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'xpssendSmsOrEmail', "Inside xpssendSmsOrEmail", PAGEACTIVITY.UA));
        let requestJson = sendRequest(mon, smsOrEmail, isMtn, visitId);
        let url = apiUrl().sendSmsOrEmail;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Please wait ... retrieving your order information", isLoaderImg: "loader" }
        });

        if (sendSmsorEmailErrAttempts < 2) {
            api(url, 'POST', requestJson).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'xpssendSmsOrEmail', "Response Success", PAGEACTIVITY.UA));
                    dispatch({ type: Save.sendSmsorEmail, value: response.data });
                    dispatch({ type: Save.sentSmsorEmailSuccess, value: true });
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'xpssendSmsOrEmail', "RESPONSE FAILED", PAGEACTIVITY.UA));
                    dispatch({ type: XPSEntry.sendSmsorEmailErr, value: true });
                    dispatch({ type: XPSEntry.sendSmsorEmailErrAttempts, value: sendSmsorEmailErrAttempts + 1 });
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
            .catch(error => {    
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:xpssendSmsOrEmail,errorMessage:${error.message}`;
                logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: XPSEntry.sendSmsorEmailErr, value: true });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'xpssendSmsOrEmail', errorMsg, PAGEACTIVITY.UA));
            })
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'xpssendSmsOrEmail', "sendSmsorEmailErrAttempts > 2", PAGEACTIVITY.UA));
            dispatch({ type: XPSEntry.sendSmsorEmailErr, value: false });
            dispatch({ type: XPSEntry.sendSmsorEmailAttemptsError, value: true });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-xpssendSmsOrEmail', ex);
    }
};

const sendRequest = (mon, smsOrEmail, isMtn,visitId) => {
    try{
        let today = new Date();
        let mm = today.getMonth() + 1;
        if (mm < 10) { mm = "0" + mm; }
        let dd = today.getDate();
        if (dd < 10) { dd = "0" + dd; }
        let y = today.getFullYear();
        let savedate = mm + '/' + dd + '/' + y;
        let request = {
            email: !isMtn ? smsOrEmail : "",
            mtn: isMtn ? smsOrEmail : "",
            mon: mon,
            deliveryType: isMtn ? "SMS" : "EMAIL",
            cartCreateDate: savedate
        }
        return JSON.stringify(request);
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-sendRequest', ex);
        return JSON.stringify({ email: "", mtn: "", mon: "", deliveryType: "", cartCreateDate: "" });
    }
};

export const loadTNForSmartCartResume = (visitId, dispatch, saveState) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadTNForSmartCartResume', "Inside loadTNForSmartCartResume", PAGEACTIVITY.UA));
        let url = apiUrl().voicetn + '/requesttn?nooftns=1';
        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code)){
                if (InHomeUtils.getIndexOf(response.meta.code, '201') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.requestedTnsOnly) && InHomeUtils.isNotEmpty(response.data.requestedTnsOnly) && response.data.requestedTnsOnly.length > 0) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadTNForSmartCartResume', "loadTNForSmartCartResume Success", PAGEACTIVITY.UA));
                    dispatch({ type: Save.loadTNForSCResume, value: response.data.requestedTnsOnly[0] });
                    dispatch({ type: 'LOAD_TN', value: response.data.requestedTnsOnly[0] });
                    saveState.loadTNForSCResume = response.data.requestedTnsOnly[0];
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "500")) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadTNForSmartCartResume', "loadTNForSmartCartResume Failed", PAGEACTIVITY.UA));
                    dispatch({ type: Save.loadTNForSCResume, value: "1000000001" });
                    dispatch({ type: 'LOAD_TN', value: "1000000001" });
                    saveState.loadTNForSCResume = "1000000001";
                }
            }
        })
        .catch(error => {
            let errorMsg = `MethodName:loadTNForSmartCartResume,errorMessage:${error.message}`;
            logKafka("ERROR", "xpsEntry", errorMsg, getErrorLogUrl, "applogs", visitId);
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadTNForSmartCartResume', errorMsg, PAGEACTIVITY.UA));
        });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'loadTNForSmartCartResume', ex);
    }
};

export const getVZFwdEnrollmentDetails = (enrollmentId, visitId, dispatch, reqData) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        const {retrievCartData, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId} = reqData;
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'getVZFwdEnrollmentDetails', "Inside getVZFwdEnrollmentDetails", PAGEACTIVITY.UA));
        let url = apiUrl().vzFwdEnrollmentDetails;
        let request = {
            clientId: "VZCOM",
            requestTrackingNumber: visitId,
            cartId: "",
            enrollmentNumber: enrollmentId
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if(response && response?.enrollmentNumber?.length > 0){
                //AEm controlled delay for resume cart
                //  if(InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.ResumeCartDelay)){
                //     setTimeout(function () {
                //         updateLQDetailsXps(dispatch, retrievCartData, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId);
                //      }, lqState.runtimeKey.ResumeCartDelay);
                // }else{
                    setTimeout(function () {
                        updateLQDetailsXps(dispatch, retrievCartData, visitId, lqState, isCreditCheckCompleted, isPersonalInfo, buildProductState, saveState,cart,firstBill,retrieveSource,cmpId);
                     }, 1000);
                //}  
            }
            else{
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            
        })
        .catch(error => {
            let errorMsg = `MethodName:getVZFwdEnrollmentDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "xpsEntry", errorMsg, getErrorLogUrl, "applogs", visitId);
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'getVZFwdEnrollmentDetails', errorMsg, PAGEACTIVITY.UA));
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'getVZFwdEnrollmentDetails', ex);
    }
};

export const getFetchEmerios = (visitId, dispatch, retrieveCartData) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'getFetchEmerios', "Inside getFetchEmerios", PAGEACTIVITY.UA));
        let url = apiUrl().fetchEmeriosInfo;
        const addressData = retrieveCartData?.addressLine2?.trim().split(" ");
        const city = addressData[0];
        const zipCode = addressData[addressData?.length - 1]
        let request = {
            registrationLanguage: "E",
            businessLine: "FIOS",
            customerType: "N",
            fiosSessionId: visitId,
            redirectUrl: `${window.location.host}/inhome/buildproducts?lq2=y&intcmp=vf3-buildproducts-continue`,
            addressLine1: retrieveCartData?.addressLine1,
            addressLine2: retrieveCartData?.addressLine2,
            city,
            state: retrieveCartData?.referralState,
            zipCode
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (response && response?.data?.status === "Success" && response?.data?.redirectUrl) {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                window.location.href = response?.data?.redirectUrl;
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }

        })
            .catch(error => {
                let errorMsg = `MethodName:getFetchEmerios,errorMessage:${error.message}`;
                logKafka("ERROR", "xpsEntry", errorMsg, getErrorLogUrl, "applogs", visitId);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'getFetchEmerios', errorMsg, PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'getFetchEmerios', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};



export const clearCart = (visitId) => {
    try {        
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', "Inside clearCart", PAGEACTIVITY.UA));        
        let url = apiUrl().clearCart + '/' + visitId;
        let request = getClearCartRequest();
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)){
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', "clearCart Success", PAGEACTIVITY.UA)); 
            }
            else{
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', "clearCart Failed", PAGEACTIVITY.UA)); 
            }
        })
        .catch(error => {
            let errorMsg = `MethodName:clearCart,errorMessage:${error.message}`;
            logKafka("ERROR", 'xpsEntry', errorMsg, getErrorLogUrl, "applogs", visitId);
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', errorMsg, PAGEACTIVITY.UA));
            
        });
    }
    catch (ex) {
        catchJSException('xpsEntry', visitId, 'clearCart', ex);
    }
};

const getClearCartRequest = () => {
    let request = { serviceType: 'ALL', productType: 'All' }
    return JSON.stringify(request)
};

export const captureSCResumeSource=(dispatch,retrieveSource,saveState,visitId)=>{
    try{        
        if (InHomeUtils.isNotNull(retrieveSource) && InHomeUtils.isNotEmpty(retrieveSource) && InHomeUtils.isNotNull(saveState) && InHomeUtils.isNotNull(saveState.scResumeSourceCaptured) && InHomeUtils.isNotEmpty(saveState.scResumeSourceCaptured) && saveState.scResumeSourceCaptured == false) {
            retrieveSource=retrieveSource.toLowerCase();
                       
            if (retrieveSource.indexOf('smart cart lq resume cancel')>-1)
            {
                updateSCTags(retrieveSource);
            }
            else{
                updateSCTags('smart cart '+retrieveSource+' resume');
                retrieveSource="smart cart "+retrieveSource+" resume";
            }            
            dispatch({
                type: 'SC_RESUME_SOURCE',
                value: true
            })
            // console.log("Smart Cart Resume Source : "+retrieveSource);
        }
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'exception while capturing SCResumeSource', ex);        
    }
}

export const preselectCartProductsForSCResume = (cartProducts,voiceProduct,dispatch,visitId, resumeFlowType, buildProductState,lqState,saveState,cart,firstBill) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'preselectCartProductsForSCResume', "Inside preselectCartProductsForSCResume", PAGEACTIVITY.UA));
        let selectedCoreServices = (InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartOrderDetail) && InHomeUtils.isNotNull(cart.cartOrderDetail.servicesOrdered)) ? cart.cartOrderDetail.servicesOrdered : '';
        let additionalInfo = { flowType: resumeFlowType, isUpsell: false, couponFlowType: null, orderType: '', vcpestbQty: '' };
        buildProductAction.PreselectCartProducts(cartProducts, dispatch, visitId, additionalInfo, null, buildProductState,lqState,cart,false,null,lqState.servicesQualified);                       
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Resuming your cart", isLoaderImg: "loader" }
        }); 
        if (InHomeUtils.isNotEmpty(selectedCoreServices)) {
        buildProductAction.smartCartSelectedCoreService(selectedCoreServices, dispatch);
        }
        if (InHomeUtils.isNotNull(voiceProduct) && InHomeUtils.isNull(buildProductState.winback.selectedProduct)) {
            let product = {}
            let tn = saveState.loadTNForSCResume;
            if (saveState && saveState.resumeIsWinback && InHomeUtils.isNotNull(saveState.resumeWinbackTN)) {
                product = {
                    displayPrice: "$4.99 One-Time fee may apply",
                    id: "WINBACKYES",
                    name: "Yes, check my number",
                    prodType: "WINBACK"
                }
                tn = saveState.resumeWinbackTN
            }
            else {
                product = {
                    displayPrice: "$0.00",
                    id: "WINBACKNO",
                    name: "No, I would like a new number",
                    prodType: "WINBACK"
                }
            }
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'preselectCartProductsForSCResume', "updateCart for Winback", PAGEACTIVITY.UA));
            buildProductAction.updateCart(visitId, lqState, product, Service.winBack, false, dispatch, tn, firstBill, null, "", "", false, false, null, buildProductState);
        }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'preselectCartProductsForSCResume', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};
export const onXpsValidateCaptcha = (captchaReq, props) => {
    try {
        let url = '/inhome/validatecaptcha';
        //url = 'https://localhost.verizon.com:8080/validatecaptcha'; // localDev
        let request = {
            'g-recaptcha-response': captchaReq
        }
        return new Promise((resolve, reject) => {
            api(url, 'POST', JSON.stringify(request)).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.responseCode) && response.responseCode === 0) {
                    props.dispatch({ type: XPSEntry.xpsCaptchaChanged, value: 'COMPLETED' });
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, props.appState.visitId, 'onValidateCaptcha', PAGEACTIVITY.MSG.CaptchaSuccess, PAGEACTIVITY.UA));
                    loaderActive({ isLoaderActive: false }, props.dispatch);
                    updateSCTags("captcha FIOS success"); 
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, props.appState.visitId, 'onValidateCaptcha', PAGEACTIVITY.MSG.CaptchaFailure, PAGEACTIVITY.UA));
                    var host = window.location.host; 
                    
                    //validatecaptcha wont give success response in non-prod hence making it success in failure case only in non-prod for testing
                    if (host === "wwwawssit.ebiz.verizon.com" || host === "orderinglite-gz-east.vpc.verizon.com" || host === "www.preprod.verizon.com" || host === "preprod-east-gz.vpc.verizon.com" || host === "wwwnte3aws.ebiz.verizon.com") {
                        props.dispatch({ type: XPSEntry.xpsCaptchaChanged, value: 'COMPLETED' });
                        loaderActive({ isLoaderActive: false }, props.dispatch);
                    }
                    updateSCTags("captcha FIOS failure");
                }
                resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:onSubmitCaptcha,errorMessage:${error.message}`;
                logKafka("ERROR", "ONXPSVALIDATECAPTCHA", errorMsg, getErrorLogUrl, "applogs", props.appState.visitId);
            });
        });
    }
    catch (ex) {       
        catchJSException(PAGEACTIVITY.PAGE.RC, this.props.appState.visitId, 'onXpsValidateCaptcha', ex);
    }
};